// @flow
import Club from 'components/club/Club';
import { connect } from 'react-redux';

import type { DispatchType, StateType } from 'types/Actions';
import type { StateProps, DispatchProps } from 'components/club/Club';
import { fetchClub } from 'actions/clubActions';

export default connect(
  (state: StateType): StateProps => ({
    club: state.clubState.club,
    status: state.clubState.status,
    userPref: state.userState.userPref
  }),
  (dispatch: DispatchType): DispatchProps => ({
    fetchClub: (slug: string) => dispatch(fetchClub(slug))
  })
)(Club);
